import { getAdminHubUrl } from '@post-office/growth-common';

const STAGING_PROMOTION_ID = 'ec28f479-70f7-4c31-9db3-f459de61be15';
const PROD_PROMOTION_ID = '3b7dd70b-b253-43fa-84cd-858fb49fad29';

export const buildPlaceOrderHref = ({
	envType,
	transactionAccountId,
	entitlementId,
	edition,
}: {
	envType: string;
	transactionAccountId: string;
	entitlementId: string;
	edition: string;
}): string => {
	const adminhubHost = getAdminHubUrl(envType.toLowerCase());

	const promotionId = envType === 'Production' ? PROD_PROMOTION_ID : STAGING_PROMOTION_ID;

	const encodedInput = Buffer.from(
		JSON.stringify({
			entitlements: [
				{
					entitlementId,
					promotionId,
					skipTrial: true,
					targetBillingCycle: 'MONTHLY',
					targetOfferingName: edition,
				},
			],
		}),
		'utf8',
	).toString('base64');

	const url = new URL(`/billing/${transactionAccountId}/place-order`, adminhubHost);
	url.searchParams.set('orderBuilderType', 'multipleEntitlementUpdates');
	url.searchParams.set('encodedMultipleEntitlementUpdatesInput', encodedInput);

	return url.toString();
};
